import { Suspense } from "react"
import { QueryErrorBoundary } from "~/components/query-error-boundary"
import { SpinnerFallback } from "~/components/spinner-fallback"
import { TitleErrorFallback } from "~/components/error"
import { TitleHeader } from "~/components/title-header"

type FallbackProps = { error: unknown }

interface QueryBoundaryProps {
  children: React.ReactNode
  loadingFallback?: React.ReactNode
  errorFallback?: React.ComponentType<FallbackProps>
}

export function QueryBoundary({
  children,
  loadingFallback = <SpinnerFallback />,
  errorFallback,
}: QueryBoundaryProps) {
  return (
    <QueryErrorBoundary fallback={errorFallback}>
      <Suspense fallback={loadingFallback}>{children}</Suspense>
    </QueryErrorBoundary>
  )
}

export function TitleQueryBoundary({
  children,
  loadingFallback = <TitleHeader />,
  errorFallback = TitleErrorFallback,
}: QueryBoundaryProps) {
  return (
    <QueryBoundary loadingFallback={loadingFallback} errorFallback={errorFallback}>
      {children}
    </QueryBoundary>
  )
}
